import { put, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";



 export const actionTypes={
    selectPortfolioIndustriesLast:"[selectPortfolioIndustriesLast] Action",
    selectPortfolioIndustriesLastpage:"[selectPortfolioIndustriesLastpage] Action",
    selectPortfolioIndustriesLastLoad:"[selectPortfolioIndustriesLastLaod] Action",
    selectPortfolioIndustriesLastPageAsync:"[selectPortfolioIndustriesLastPageAsync] Action",
    selectPortfolioIndustriesLastAsync:"[selectPortfolioIndustriesLastAsync] Action",
}


const initialState = {
    data:[],
    datapage:[],
    loading:false,
    total:0
}

 export const select_last_portfolio_industries_reducer = (state=initialState,{type,payload})=>{

    switch (type) {
        case actionTypes.selectPortfolioIndustriesLast:
            return{
                ...state,
                data: payload?.data?.results ? payload?.data?.results :[],
                // total:payload?.data?.total ? payload?.data?.total :0
            }
        case actionTypes.selectPortfolioIndustriesLastpage:
            return{
                ...state,
                datapage: payload?.data?.results ? payload?.data?.results :[],
                total:payload?.data?.total ? payload?.data?.total :0
            }
        case actionTypes.selectPortfolioIndustriesLastLoad:
            return{
                ...state,
                loading:payload
            }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectPortfolioIndustriesLastLoad, payload: true });
    let config = {
        url: "select_request"
    };
    
    let data = {
        table: "portfolio",
        method_type: "select_last_portfolio_industries",
        data: payload?.data ? payload.data : {},
    };
    
    try {
      let res = yield AxiosCustom(config, data);

      yield put({type:actionTypes.selectPortfolioIndustriesLast,payload:res.data.response})
    } catch {
      handleNotificationAlertCatch();
    }finally{
        yield put({ type: actionTypes.selectPortfolioIndustriesLastLoad, payload: false });

    }
  }


function* handleWorkerPage({ payload }) {
    // yield put({ type: actionTypes.selectPortfolioIndustriesLastLoad, payload: true });
    let config = {
        url: "select_request"
    };

    
    let data = {
        table: "portfolio",
        method_type: "select_last_portfolio_industries",
        from:payload.from?payload.from:0,
        size:payload.size?payload.size:1000,
        data: payload?.data ? payload.data : {},
    };
    
    try {
        let res = yield AxiosCustom(config, data);
        
        yield put({type:actionTypes.selectPortfolioIndustriesLastpage,payload:res.data.response})
    } catch {
        handleNotificationAlertCatch();
    }finally{
        // yield put({ type: actionTypes.selectPortfolioIndustriesLastLoad, payload: false });
        
    }
}

export function* selectPortfolioindustriesLast() {

      yield takeEvery(actionTypes.selectPortfolioIndustriesLastPageAsync, handleWorkerPage);
    yield takeEvery(actionTypes.selectPortfolioIndustriesLastAsync, handleWorker);
  }